import { get } from '@/utils/request'
import useSWR from 'swr'
import { teamType, turnType } from '@/utils/types'
import { decrypt, getMatchEncryptedKey } from '@/utils/crypto'
import { commonSWROptions } from './useAdmin'

const fetchRelatedTeams = (match_id: string, match_type, is_encrypted) => {
  let path = 'users/teams/related'
  if (match_type === 'league') {
    path = 'users/teams'
  }
  return get(path, { match_id, turn: 'sum' }).then((res) => {
    if (res.ok) {
      let teams = res.teams ?? []
      if (is_encrypted) {
        const key = getMatchEncryptedKey(match_id)
        if (key) {
          teams = teams.map((t) => {
            if (t.name_user1 && t.name_user1 !== '空') t.name_user1 = decrypt(t.name_user1, key)
            if (t.name_user2 && t.name_user2 !== '空') t.name_user2 = decrypt(t.name_user2, key)
            return t
          })
          return teams
        }
      }
      return teams
    }
    return []
  })
}

export const fetchTeam = (team_id: string) =>
  get(`users/teams/${team_id}`).then((res) => {
    if (res.ok) {
      return { ...res, rounds: res.rounds ?? [], team: res.team ?? {} }
    }
    return { ...res, rounds: [], team: {} }
  })
const fetchTeams = (match_id: string, turn: turnType, is_encrypted = false) =>
  get('users/teams', { match_id, turn }).then((res) => {
    if (res.ok) {
      let teams = res.teams ?? []
      if (is_encrypted) {
        const key = getMatchEncryptedKey(match_id)
        if (key) {
          teams = teams.map((t) => {
            if (t.name_user1 && t.name_user1 !== '空') t.name_user1 = decrypt(t.name_user1, key)
            if (t.name_user2 && t.name_user2 !== '空') t.name_user2 = decrypt(t.name_user2, key)
            return t
          })
          return teams
        }
      }
      return teams
    }
    return []
  })

export const useTeams = (match_id, turn: turnType = 'sum', is_encrypted = false) => {
  return useSWR(match_id ? `teams-${match_id}-${turn}` : undefined, () => fetchTeams(match_id, turn, is_encrypted), {
    ...commonSWROptions,
    fallbackData: [],
  }) as {
    data: teamType[]
    mutate: any
    isValidating: boolean
  }
}

export const useRelatedTeams = (match_id, match_type, is_encrypted = false) => {
  return useSWR(match_id && match_type ? `related-teams-${match_id}-${match_type}` : undefined, () => fetchRelatedTeams(match_id, match_type, is_encrypted), {
    ...commonSWROptions,
    fallbackData: [],
  }) as {
    data: teamType[]
    mutate: any
    isValidating: boolean
  }
}

export const useTeam = (team_id) => {
  return useSWR(team_id ? `team-${team_id}` : undefined, () => fetchTeam(team_id), {
    ...commonSWROptions,
    fallbackData: { rounds: [], team: {} },
  }) as {
    data: { rounds: any; team: teamType; match: any }
    mutate: any
    isValidating: boolean
  }
}
